import React, { useState, useEffect, useRef } from "react";
import Card from "components/Card";
import useMessages from "customHook/useMessages";
import MessageItem from "screens/Home/components/MessageItem";
import { useMutation } from "@apollo/client";
import { MARK_ALL_INCOMING_MESSAGES_AS_READ } from "graphql/service";
import ModalClearAll from "screens/ModalClearAll";
import { Container, MessageContainer, Spinner } from "./styles";
import moment from "moment-timezone";
import { TIME_ZONE } from "constants/constant";
import { debouncedErrorMessage } from "utils/messageUtil";

const Messages = ({ mobile }) => {
  const [hasMore, setHasMore] = useState(true);
  const {
    markMessageAsRead,
    markMessageAsUnread,
    pageSize,
    offset,
    setOffset,
    fetchMore,
    loading,
    messages,
    setMessages,
  } = useMessages();
  const listRef = useRef(null);

  useEffect(() => {
    const listElement = listRef.current;
    if (!listElement) return;

    const handleScroll = () => {
      const { scrollTop, clientHeight, scrollHeight } = listElement;
      const scrolledToBottom = scrollHeight - scrollTop <= clientHeight + 100;
      if (scrolledToBottom && !loading && hasMore) {
        fetchMore({
          variables: {
            input: {
              pagination: {
                limit: pageSize,
                offset: offset + pageSize,
              },
            },
          },
          updateQuery: (prev, { fetchMoreResult }) => {
            if (
              !fetchMoreResult ||
              !fetchMoreResult.latestIncomingMessages?.items.length
            ) {
              setHasMore(false);
              return prev;
            }
            return {
              ...prev,
              latestIncomingMessages: {
                ...prev.latestIncomingMessages,
                items: [
                  ...prev.latestIncomingMessages.items,
                  ...fetchMoreResult.latestIncomingMessages.items,
                ],
              },
            };
          },
        })
          .then(() => {
            setOffset(offset + pageSize);
          })
          .catch((error) => {
            if (!error.networkError) {
              let content = error.message;
              if (error.message.includes("Validation")) {
                content = JSON.stringify(
                  error.graphQLErrors[0]?.extensions?.exception
                );
              }
              debouncedErrorMessage(content);
            }
          });
      }
    };

    listElement.addEventListener("scroll", handleScroll);
    return () => listElement.removeEventListener("scroll", handleScroll);
  }, [loading, fetchMore, hasMore, offset, pageSize, setOffset]);

  const [
    markAllIncomingMessagesAsRead,
    { loading: markAllIncomingMessagesAsReadLoading },
  ] = useMutation(MARK_ALL_INCOMING_MESSAGES_AS_READ, {
    onCompleted: () => {
      setMessages(prevMessages => prevMessages.map(message => ({ ...message, isRead: true })));
    },
    onError: (error) => {
      if (!error.networkError) {
        let content = error.message;
        if (error.message.includes("Validation")) {
          content = JSON.stringify(
            error.graphQLErrors[0]?.extensions?.exception
          );
        }
        debouncedErrorMessage(content);
      }
    },
  });

  if (loading) return <p></p>;

  const messageArray = messages.map((message) => {
    return (
      <MessageItem
        key={message.messageId}
        mobile={mobile}
        markIncomingMessagesAsRead={markAllIncomingMessagesAsRead}
        markIncomingMessagesAsUnread={markMessageAsUnread}
        messageId={message.messageId}
        roomNumber={"missing"}
        tenantId={message.sender.userId}
        contactValue={message.sender.contactValue}
        type={message.channel}
        description={message.body}
        originator={"missing"}
        createdAt={message.createdAt}
        isRead={message.isDeleted}
        setMessages={setMessages}
      />
    );
  }) || [];

  return (
    <Container mobile={mobile}>
      <Card
        additionalstyle={`
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: flex-start;
        `}
      >
        <div className="title">MESSAGES</div>
        <ModalClearAll
          buttonStyle={`
            width: 80px
          `}
          loading={markAllIncomingMessagesAsReadLoading}
          clearFunction={markAllIncomingMessagesAsRead}
          type="message"
        />
      </Card>
      <MessageContainer mobile={mobile} ref={listRef}>
        {messageArray}
        {(!hasMore || messageArray.length === 0)? <span className='noMoreMessages'>There is nothing else here.</span> :loading? <Spinner />: null }
        {/* {
          <>
            <MessageItem
              mobile={mobile}
              messageId={"891b25f5-8a30-4475-a383-8488e21863d0"}
              roomNumber={"825"}
              tenantId={"981b25f5-8a30-4475-a383-8488e21863d0"}
              type={"Text"}
              description={
                "First line of message blah blah yada yada yada truncated…"
              }
              originator="Nancy Hachisu"
              createdAt={moment().tz(TIME_ZONE).format("MMM Do YYYY h:mm A")}
            />
            <MessageItem
              mobile={mobile}
              messageId={"891b25f5-8a30-4475-a383-8488e21863d0"}
              roomNumber={"825"}
              tenantId={"981b25f5-8a30-4475-a383-8488e21863d0"}
              type={"Text"}
              description={
                "First line of message blah blah yada yada yada truncated…"
              }
              originator="Nancy Hachisu"
              createdAt={moment().tz(TIME_ZONE).format("MMM Do YYYY h:mm A")}
            />
            <MessageItem
              mobile={mobile}
              messageId={"891b25f5-8a30-4475-a383-8488e21863d0"}
              roomNumber={"825"}
              tenantId={"981b25f5-8a30-4475-a383-8488e21863d0"}
              type={"Text"}
              description={
                "First line of message blah blah yada yada yada truncated…"
              }
              originator="Nancy Hachisu"
              createdAt={moment().tz(TIME_ZONE).format("MMM Do YYYY h:mm A")}
            />
            <MessageItem
              mobile={mobile}
              messageId={"891b25f5-8a30-4475-a383-8488e21863d0"}
              roomNumber={"825"}
              tenantId={"981b25f5-8a30-4475-a383-8488e21863d0"}
              type={"Text"}
              description={
                "First line of message blah blah yada yada yada truncated…"
              }
              originator="Nancy Hachisu"
              createdAt={moment().tz(TIME_ZONE).format("MMM Do YYYY h:mm A")}
            />
            <MessageItem
              mobile={mobile}
              messageId={"891b25f5-8a30-4475-a383-8488e21863d0"}
              roomNumber={"825"}
              tenantId={"981b25f5-8a30-4475-a383-8488e21863d0"}
              type={"Text"}
              description={
                "First line of message blah blah yada yada yada truncated…"
              }
              originator="Nancy Hachisu"
              createdAt={moment().tz(TIME_ZONE).format("MMM Do YYYY h:mm A")}
            />
            <MessageItem
              mobile={mobile}
              messageId={"891b25f5-8a30-4475-a383-8488e21863d0"}
              roomNumber={"825"}
              tenantId={"981b25f5-8a30-4475-a383-8488e21863d0"}
              type={"Text"}
              description={
                "First line of message blah blah yada yada yada truncated…"
              }
              originator="Nancy Hachisu"
              createdAt={moment().tz(TIME_ZONE).format("MMM Do YYYY h:mm A")}
            />
            <MessageItem
              mobile={mobile}
              messageId={"891b25f5-8a30-4475-a383-8488e21863d0"}
              roomNumber={"825"}
              tenantId={"981b25f5-8a30-4475-a383-8488e21863d0"}
              type={"Text"}
              description={
                "First line of message blah blah yada yada yada truncated…"
              }
              originator="Nancy Hachisu"
              createdAt={moment().tz(TIME_ZONE).format("MMM Do YYYY h:mm A")}
            />
            <MessageItem
              mobile={mobile}
              messageId={"891b25f5-8a30-4475-a383-8488e21863d0"}
              roomNumber={"825"}
              tenantId={"981b25f5-8a30-4475-a383-8488e21863d0"}
              type={"Text"}
              description={
                "First line of message blah blah yada yada yada truncated…"
              }
              originator="Nancy Hachisu"
              createdAt={moment().tz(TIME_ZONE).format("MMM Do YYYY h:mm A")}
            />
            <MessageItem
              mobile={mobile}
              messageId={"891b25f5-8a30-4475-a383-8488e21863d0"}
              roomNumber={"825"}
              tenantId={"981b25f5-8a30-4475-a383-8488e21863d0"}
              type={"Text"}
              description={
                "First line of message blah blah yada yada yada truncated…"
              }
              originator="Nancy Hachisu"
              createdAt={moment().tz(TIME_ZONE).format("MMM Do YYYY h:mm A")}
            />
            <MessageItem
              mobile={mobile}
              messageId={"891b25f5-8a30-4475-a383-8488e21863d0"}
              roomNumber={"825"}
              tenantId={"981b25f5-8a30-4475-a383-8488e21863d0"}
              type={"Text"}
              description={
                "First line of message blah blah yada yada yada truncated…"
              }
              originator="Nancy Hachisu"
              createdAt={moment().tz(TIME_ZONE).format("MMM Do YYYY h:mm A")}
            />
            <MessageItem
              mobile={mobile}
              messageId={"891b25f5-8a30-4475-a383-8488e21863d0"}
              roomNumber={"825"}
              tenantId={"981b25f5-8a30-4475-a383-8488e21863d0"}
              type={"Text"}
              description={
                "First line of message blah blah yada yada yada truncated…"
              }
              originator="Nancy Hachisu"
              createdAt={moment().tz(TIME_ZONE).format("MMM Do YYYY h:mm A")}
            />
            <MessageItem
              mobile={mobile}
              messageId={"891b25f5-8a30-4475-a383-8488e21863d0"}
              roomNumber={"825"}
              tenantId={"981b25f5-8a30-4475-a383-8488e21863d0"}
              type={"Text"}
              description={
                "First line of message blah blah yada yada yada truncated…"
              }
              originator="Nancy Hachisu"
              createdAt={moment().tz(TIME_ZONE).format("MMM Do YYYY h:mm A")}
            />
            <MessageItem
              mobile={mobile}
              messageId={"891b25f5-8a30-4475-a383-8488e21863d0"}
              roomNumber={"825"}
              tenantId={"981b25f5-8a30-4475-a383-8488e21863d0"}
              type={"Text"}
              description={
                "First line of message blah blah yada yada yada truncated…"
              }
              originator="Nancy Hachisu"
              createdAt={moment().tz(TIME_ZONE).format("MMM Do YYYY h:mm A")}
            />
            <MessageItem
              mobile={mobile}
              messageId={"891b25f5-8a30-4475-a383-8488e21863d0"}
              roomNumber={"825"}
              tenantId={"981b25f5-8a30-4475-a383-8488e21863d0"}
              type={"Text"}
              description={
                "First line of message blah blah yada yada yada truncated…"
              }
              originator="Nancy Hachisu"
              createdAt={moment().tz(TIME_ZONE).format("MMM Do YYYY h:mm A")}
            />
            <MessageItem
              mobile={mobile}
              messageId={"891b25f5-8a30-4475-a383-8488e21863d0"}
              roomNumber={"825"}
              tenantId={"981b25f5-8a30-4475-a383-8488e21863d0"}
              type={"Text"}
              description={
                "First line of message blah blah yada yada yada truncated…"
              }
              originator="Nancy Hachisu"
              createdAt={moment().tz(TIME_ZONE).format("MMM Do YYYY h:mm A")}
            />
            <MessageItem
              mobile={mobile}
              messageId={"891b25f5-8a30-4475-a383-8488e21863d0"}
              roomNumber={"825"}
              tenantId={"981b25f5-8a30-4475-a383-8488e21863d0"}
              type={"Text"}
              description={
                "First line of message blah blah yada yada yada truncated…"
              }
              originator="Nancy Hachisu"
              createdAt={moment().tz(TIME_ZONE).format("MMM Do YYYY h:mm A")}
            />
            <MessageItem
              mobile={mobile}
              messageId={"891b25f5-8a30-4475-a383-8488e21863d0"}
              roomNumber={"825"}
              tenantId={"981b25f5-8a30-4475-a383-8488e21863d0"}
              type={"Text"}
              description={
                "First line of message blah blah yada yada yada truncated…"
              }
              originator="Nancy Hachisu"
              createdAt={moment().tz(TIME_ZONE).format("MMM Do YYYY h:mm A")}
            />
            <MessageItem
              mobile={mobile}
              messageId={"891b25f5-8a30-4475-a383-8488e21863d0"}
              roomNumber={"825"}
              tenantId={"981b25f5-8a30-4475-a383-8488e21863d0"}
              type={"Text"}
              description={
                "First line of message blah blah yada yada yada truncated…"
              }
              originator="Nancy Hachisu"
              createdAt={moment().tz(TIME_ZONE).format("MMM Do YYYY h:mm A")}
            />
            <MessageItem
              mobile={mobile}
              messageId={"891b25f5-8a30-4475-a383-8488e21863d0"}
              roomNumber={"825"}
              tenantId={"981b25f5-8a30-4475-a383-8488e21863d0"}
              type={"Text"}
              description={
                "First line of message blah blah yada yada yada truncated…"
              }
              originator="Nancy Hachisu"
              createdAt={moment().tz(TIME_ZONE).format("MMM Do YYYY h:mm A")}
            />
            <MessageItem
              mobile={mobile}
              messageId={"891b25f5-8a30-4475-a383-8488e21863d0"}
              roomNumber={"825"}
              tenantId={"981b25f5-8a30-4475-a383-8488e21863d0"}
              type={"Text"}
              description={
                "First line of message blah blah yada yada yada truncated…"
              }
              originator="Nancy Hachisu"
              createdAt={moment().tz(TIME_ZONE).format("MMM Do YYYY h:mm A")}
            />
          </>
        } */}
      </MessageContainer>
    </Container>
  );
};

export default Messages;
